import { UnifiedUpload } from "@/shared/ui/UnifiedUpload";
import { X } from "lucide-react"; // ou Trash, se preferir

interface GalleryItemProps {
  id: string;
  before: string | null;
  after: string | null;
  onChange: (type: 'before' | 'after', e: React.ChangeEvent<HTMLInputElement>) => void;
  onRemove: (id: string) => void;
  isLoading?: boolean;
  hasPermissionError?: boolean;
}

export const GalleryItem = ({
  id,
  before,
  after,
  onChange,
  onRemove,
  isLoading = false,
  hasPermissionError = false
}: GalleryItemProps) => {
  return (
    <div className="bg-white/5 rounded-xl p-4 relative inline-block">
      <button
        type="button"
        onClick={() => onRemove(id)}
        className="absolute z-10 top-2 right-2 text-white bg-black/50 hover:bg-black/70 transition-colors p-1.5 rounded-full shadow-md focus:outline-none focus:ring-2 focus:ring-offset-2 focus:ring-red-500"
        aria-label="Remover item da galeria"
      >
        <X size={16} strokeWidth={2.5} />
      </button>

      {/* Container fixo com duas colunas, nunca empilha */}
      <div className="flex flex-row gap-6 min-w-full">
        <UnifiedUpload
          id={`before-${id}`}
          title="Antes"
          preview={before}
          onFileChange={(e) => onChange("before", e)}
          showRemoveButton={false}
          onRemove={() => { }}
          acceptTypes="image/*"
          variant="cover"
          enableDragDrop={!isLoading}
          maxSizeMB={0.5}

        />

        <UnifiedUpload
          id={`after-${id}`}
          title="Depois"
          preview={after}
          onFileChange={(e) => onChange("after", e)}
          showRemoveButton={false}
          onRemove={() => { }}
          acceptTypes="image/*"
          variant="cover"
          enableDragDrop={!isLoading}
          maxSizeMB={0.5}
        />
      </div>

      {hasPermissionError && (
        <div className="mt-2 text-red-400 text-sm">
          Erro de permissão ao acessar esta galeria
        </div>
      )}
    </div>

  );
};
